import TimeTable from '../../../UIComponents/DataWidgets/TimeTable';
import TimeDiagram from '../../../UIComponents/DataWidgets/TimeDiagram';

export default function DocsSecondTableTC(props) {
    const { widgetType, widgetLabel, dataArr: dataArrInc, widgetLegend } = props
    const dataArr = dataArrInc.map((item)=>({...item, rawValue:parseInt(item.rawValue)}))

    if (widgetType === "timeTable") {
      return (
          <>
            <TimeTable  widgetLabel={widgetLabel} dataArr={dataArr} />
          </>
      )
    } else if (widgetType === "timeDiagram" || widgetType === "timeDiagram.noLegend") {
      return <TimeDiagram widgetType={widgetType} widgetLabel={widgetLabel} dataArr={dataArr} widgetLegend={widgetLegend} />
    } else {
        return null
    }
}
